import React, { useContext, useEffect } from "react";
import { getPromoterLabels, initialPromoterFilter } from "./FilterTypes/PromoterFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import PromoterMultiPicker from "components/Picker/PromoterPicker/PromoterMultiPicker";

const PromoterFilter = () => {
  const title = site.currentEnvironment.functionGroups.promoter.singular;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("promoter", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getPromoterLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedPromoters.length > 0,
    reset: () => initialPromoterFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedPromoters.map(p => p.companyId), b.selectedPromoters.map(p => p.companyId))
  });
  useEffect(() => {
    setInitialValue("promoter", initialPromoterFilter);
  }, []);

  const [selectedPromoters, setSelectedPromoters] = React.useState<server.dto.CompanySmall[]>(initialPromoterFilter.selectedPromoters);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedPromoters(getValue("promoter").selectedPromoters);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("promoter", {
      selectedPromoters
    });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.functionGroups.promoter.enabled) {
    return <></>;
  }

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <PromoterMultiPicker
        selectedPromoters={selectedPromoters}
        onChange={setSelectedPromoters}
      />
    </MultiPickerFilterPopup>
  </div>
};

export default PromoterFilter;
